var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "文件名称",
                        "label-col": { span: 6 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["infoName", _vm.rules.infoName],
                            expression: "['infoName',rules.infoName]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#ff0000",
                        "line-height": "30px",
                        "padding-left": "11%",
                      },
                    },
                    [
                      _vm._v(
                        " 文件类型:（仅可选择一类文件类型，若切换则已填写内容会被清空） "
                      ),
                    ]
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "文件类型",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { "button-style": "solid" },
                          on: {
                            change: function ($event) {
                              return _vm.toggleType(_vm.infoClassify)
                            },
                          },
                          model: {
                            value: _vm.infoClassify,
                            callback: function ($$v) {
                              _vm.infoClassify = $$v
                            },
                            expression: "infoClassify",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "image" } }, [
                            _vm._v("图片"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "video" } }, [
                            _vm._v("视频"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "file" } }, [
                            _vm._v("文件"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _vm.infoClassify === "image"
                    ? [
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              label: "图片设置",
                              "label-col": { span: 4 },
                              "wrapper-col": { span: 20 },
                            },
                          },
                          [
                            _c("uploader", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["infoUrl", _vm.rules.infoUrl],
                                  expression: "['infoUrl', rules.infoUrl]",
                                },
                              ],
                              attrs: {
                                num: 9,
                                accept: ".jpg,.jpeg,.PNG,.JPG,.JPEG",
                                url: _vm.api.temp.UPLOAD_TALK,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#f00",
                              "margin-left": "16.66666666666666666%",
                            },
                          },
                          [
                            _vm._v(
                              "建议格式：.png,.jpg, 最大为10MB,最多不超过9张"
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm.infoClassify === "video"
                    ? [
                        _c(
                          "a-form-item",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              label: "视频封面",
                              "label-col": { span: 4 },
                              "wrapper-col": { span: 20 },
                            },
                          },
                          [
                            _c("uploader", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["coverImg"],
                                  expression: "['coverImg']",
                                },
                              ],
                              ref: "videoCoverUploader",
                              attrs: {
                                num: 1,
                                accept: "image/*",
                                url: _vm.api.temp.UPLOAD_LIMIT,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              label: "视频设置",
                              "label-col": { span: 4 },
                              "wrapper-col": { span: 20 },
                            },
                          },
                          [
                            _c("uploader", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["infoUrl", _vm.rules.infoUrl],
                                  expression: "['infoUrl', rules.infoUrl]",
                                },
                              ],
                              ref: "videoUploader",
                              attrs: {
                                num: 1,
                                accept: ".mp4",
                                url: _vm.api.temp.UPLOAD_TALK,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#f00",
                              "margin-left": "16.66666666666666666%",
                            },
                          },
                          [_vm._v("建议格式：.mp4，最大为10MB，最多1个")]
                        ),
                      ]
                    : _vm._e(),
                  _vm.infoClassify === "file"
                    ? [
                        _c(
                          "a-form-item",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              label: "文件封面",
                              "label-col": { span: 4 },
                              "wrapper-col": { span: 20 },
                            },
                          },
                          [
                            _c("uploader", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["coverImg"],
                                  expression: "['coverImg']",
                                },
                              ],
                              attrs: {
                                num: 1,
                                accept: "image/*",
                                url: _vm.api.temp.UPLOAD_LIMIT,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              label: "文件",
                              "label-col": { span: 4 },
                              "wrapper-col": { span: 20 },
                            },
                          },
                          [
                            _c("uploader", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["infoUrl", _vm.rules.infoUrl],
                                  expression: "['infoUrl', rules.infoUrl]",
                                },
                              ],
                              attrs: {
                                num: 1,
                                accept:
                                  ".xlsx,.ppt,.doc,.pdf,.txt,.xls,.docx,.pptx",
                                url: _vm.api.temp.UPLOAD_TALK,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#f00",
                              "margin-left": "16.66666666666666666%",
                            },
                          },
                          [
                            _vm._v(
                              "建议格式.xlsx,.ppt,.doc,.pdf,.txt,.xls,.docx,.pptx文件，最大为20MB，最多1个"
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "文件分组" } },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["infoTypeId", _vm.rules.infoTypeId],
                            expression: "['infoTypeId',rules.infoTypeId]",
                          },
                        ],
                        attrs: {
                          "allow-clear": "",
                          "dropdown-style": {
                            maxHeight: "300px",
                            overflow: "auto",
                          },
                          treeData: _vm.treeData,
                          replaceFields: {
                            children: "children",
                            title: "infoTypeName",
                            key: "infoTypeId",
                            value: "infoTypeId",
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "关键词",
                        "label-col": { span: 6 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["keyWords"],
                            expression: "['keyWords']",
                          },
                        ],
                        attrs: { mode: "multiple", options: _vm.tagOptions },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-button",
                    { attrs: { type: "link" }, on: { click: _vm.addTag } },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "a-button",
                    { attrs: { type: "link" }, on: { click: _vm.refreshTag } },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "新增关键词",
            closable: true,
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 600,
          },
          on: { cancel: _vm.closeEdit },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }